import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchProduct, updateProduct } from '../services/productService';

/**
 * Hook for fetching a single product
 * @param {string} id - ID of the product to fetch
 * @returns {import('@tanstack/react-query').UseQueryResult<import('../types').Product, Error>}
 */
export function useProduct(id) {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => fetchProduct(id),
  });
}

/**
 * Hook for updating a product
 * @param {string} id - ID of the product to update
 * @returns {import('@tanstack/react-query').UseMutationResult<import('../types').Product, Error, Partial<import('../types').Product>>}
 */
export function useUpdateProduct(id) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => updateProduct(id, data),
    onSuccess: (updatedProduct) => {
      queryClient.setQueryData(['product', id], updatedProduct);
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
} 